import React, { useState } from 'react';
import axios from 'axios';

function AuthForm({ onAuth }) {
  const [mode, setMode] = useState('login'); // 'login' | 'register' | 'forgot'
  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    number: ''
  });
  const [loading, setLoading] = useState(false);
  const [forgotMessage, setForgotMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const endpoint = mode === 'register' ? '/api/auth/register' : '/api/auth/login';
      const payload = mode === 'register'
        ? { name: form.name, email: form.email, password: form.password, number: form.number }
        : { email: form.email, password: form.password };

      const response = await axios.post(endpoint, payload);
      onAuth(response.data);
    } catch (error) {
      const message = error.response?.data?.error || 'Authentication failed';
      alert(message);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setForgotMessage('');

    try {
      await axios.post('/api/auth/forgot-password', { email: form.email });
      setForgotMessage('Check your email for a reset link.');
    } catch (error) {
      setForgotMessage('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (mode === 'forgot') {
    return (
      <div className="card" style={{ maxWidth: '520px', margin: '40px auto' }}>
        <h2 style={{ marginTop: 0, marginBottom: '12px', color: '#333' }}>
          Reset your password
        </h2>
        <p style={{ marginTop: 0, color: '#666' }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>

        {forgotMessage && (
          <div style={{
            padding: '12px 16px',
            borderRadius: '8px',
            marginBottom: '16px',
            background: forgotMessage.includes('Check') ? '#ecfdf5' : '#fef2f2',
            color: forgotMessage.includes('Check') ? '#065f46' : '#991b1b',
            fontSize: '14px'
          }}>
            {forgotMessage}
          </div>
        )}

        <form onSubmit={handleForgotSubmit}>
          <div style={{ marginBottom: '18px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600' }}>Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
              autoComplete="email"
              style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={{ marginTop: '16px' }}>
          <button
            type="button"
            onClick={() => { setMode('login'); setForgotMessage(''); }}
            className="btn btn-secondary"
          >
            Back to Sign in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="card" style={{ maxWidth: '520px', margin: '40px auto' }}>
      <h2 style={{ marginTop: 0, marginBottom: '12px', color: '#333' }}>
        {mode === 'register' ? 'Create your account' : 'Sign in'}
      </h2>
      <p style={{ marginTop: 0, color: '#666' }}>
        {mode === 'register'
          ? 'Register to start managing contacts, projects, and tasks.'
          : 'Welcome back. Sign in to continue.'}
      </p>

      <form onSubmit={handleSubmit}>
        {mode === 'register' && (
          <>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600' }}>Name</label>
              <input
                type="text"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
              />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600' }}>Phone (optional)</label>
              <input
                type="tel"
                value={form.number}
                onChange={(e) => setForm({ ...form, number: e.target.value })}
                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
              />
            </div>
          </>
        )}

        <div style={{ marginBottom: '14px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600' }}>Email</label>
          <input
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
            autoComplete="email"
            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
          />
        </div>

        <div style={{ marginBottom: '8px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600' }}>Password</label>
          <input
            type="password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
            autoComplete={mode === 'register' ? 'new-password' : 'current-password'}
            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
          />
        </div>

        {mode === 'login' && (
          <div style={{ marginBottom: '18px', textAlign: 'right' }}>
            <button
              type="button"
              onClick={() => setMode('forgot')}
              style={{
                background: 'none',
                border: 'none',
                color: '#667eea',
                cursor: 'pointer',
                fontSize: '13px',
                padding: 0,
                textDecoration: 'underline'
              }}
            >
              Forgot Password?
            </button>
          </div>
        )}

        {mode === 'register' && <div style={{ marginBottom: '10px' }} />}

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Please wait...' : mode === 'register' ? 'Create account' : 'Sign in'}
        </button>
      </form>

      <div style={{ marginTop: '16px' }}>
        <button
          type="button"
          onClick={() => setMode(mode === 'register' ? 'login' : 'register')}
          className="btn btn-secondary"
        >
          {mode === 'register' ? 'Have an account? Sign in' : 'Need an account? Register'}
        </button>
      </div>
    </div>
  );
}

export default AuthForm;
